document.querySelectorAll('.animation-border').forEach(card => {
  let animationId;
  let isHovering = false;

  card.addEventListener('mouseenter', () => {
    isHovering = true;

    let currentAngle = parseFloat(getComputedStyle(card).getPropertyValue('--angle')) || -35.7;

    const rotateGradient = () => {
      currentAngle += 2;
      if (currentAngle >= 360) currentAngle = 0;

      card.style.setProperty('--angle', `${currentAngle}deg`);

      if (isHovering) animationId = requestAnimationFrame(rotateGradient);
    };

    animationId = requestAnimationFrame(rotateGradient);
  });

  card.addEventListener('mouseleave', () => {
    isHovering = false;
    cancelAnimationFrame(animationId);

    card.style.setProperty('--angle', '-35.7deg'); 
  });
});
